import { render, staticRenderFns } from "./ManageProductPlus.vue?vue&type=template&id=cacb6ce6&scoped=true"
import script from "./ManageProductPlus.vue?vue&type=script&lang=js"
export * from "./ManageProductPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cacb6ce6",
  null
  
)

export default component.exports